import React from "react";
import Content from "../sections/Resetpassword/Content";

export const ResetPassword = (props) => {
  return (
    <div className="ms-body ms-primary-theme ms-logged-out">
      <main className="body-content">
        <Content />
      </main>
    </div>
  );
};

export default ResetPassword;
